module.exports = __webpack_public_path__ + "static/media/EICHERMOT.77b3033b.txt";